// extracted by mini-css-extract-plugin
export default {"footer_social":"styles_footer_social__TXFrn","footer_social_link":"styles_footer_social_link__JJroT"};